import type { Grade8Chapter } from "./grade8Syllabus";

/** Class 7 Deepakam table of contents, taken from CHAPTERS_INFO in HomePage. */
export const GRADE_7_SYLLABUS: Grade8Chapter[] = [
  {
    id: "gsde101",
    num: "Chapter 1 (Pages 1–7)",
    chNumber: "Chapter 1 (Pages 1–7)",
    title: "वन्दे भारतमातरम् (पाठः पृष्ठानि १-७)",
    englishTitle: "Salutations to Mother India",
    page: "Pages 1–7",
    category: "shlokas",
    genreBadge: "प्रार्थना · Patriotism",
    theme: "National prayer celebrating the natural and spiritual glory of India",
    grammarFocus: "सम्बोधनम् & द्वितीया-विभक्तिः",
    status: "available",
    icon: "🇮🇳",
  },
  {
    id: "gsde102",
    num: "Chapter 2 (Pages 15–21)",
    chNumber: "Chapter 2 (Pages 15–21)",
    title: "नित्यं पिबामः सुभाषितरसम् (पाठः पृष्ठानि १५-२१)",
    englishTitle: "Daily Nectar of Wise Sayings",
    page: "Pages 15–21",
    category: "shlokas",
    genreBadge: "सुभाषितानि · Moral Wisdom",
    theme: "Timeless morals on sweet speech, charity, virtue, and steadfast conduct",
    grammarFocus: "प्रथमा-तृतीया विभक्तयः, अव्ययानि",
    status: "available",
    icon: "📜",
  },
  {
    id: "gsde103",
    num: "Chapter 3 (Pages 29–31)",
    chNumber: "Chapter 3 (Pages 29–31)",
    title: "मित्राय नमः (पाठः पृष्ठानि २९-३१)",
    englishTitle: "Salutations to the Friend (Sun)",
    page: "Pages 29–31",
    category: "dialogue",
    genreBadge: "संवादः · Health & Yoga",
    theme: "Conversation on Surya Namaskar, physical wellness, and solar salutations",
    grammarFocus: "चतुर्थी-विभक्तिः (नमः योगे)",
    status: "available",
    icon: "☀️",
  },
  {
    id: "gsde104",
    num: "Chapter 4 (Pages 39–41)",
    chNumber: "Chapter 4 (Pages 39–41)",
    title: "न लभ्यते चेत् आम्लं द्राक्षाफलम् (पाठः पृष्ठानि ३९-४१)",
    englishTitle: "Sour Grapes (Animal Fable)",
    page: "Pages 39–41",
    category: "stories",
    genreBadge: "नीतिकथा · Animal Fable",
    theme: "Humorous fable of the thirsty fox and sour grapes illustrating rationalization",
    grammarFocus: "लट्-लकारः, विशेषण-विशेष्यम्",
    status: "available",
    icon: "🍇",
  },
  {
    id: "gsde105",
    num: "Chapter 5 (Pages 47–50)",
    chNumber: "Chapter 5 (Pages 47–50)",
    title: "सेवा हि परमो धर्मः (पाठः पृष्ठानि ४७-५०)",
    englishTitle: "Service is the Highest Virtue",
    page: "Pages 47–50",
    category: "stories",
    genreBadge: "कथा · Character Building",
    theme: "Inspiring story of selfless devotion, serving the elderly, and moral duty",
    grammarFocus: "तृतीया-विभक्तिः (सह योगे), क्त्वा-प्रत्ययः",
    status: "available",
    icon: "🤝",
  },
  {
    id: "gsde106",
    num: "Chapter 6",
    chNumber: "Chapter 6",
    title: "क्रीडाम वयं श्लोकान्त्याक्षरीम्",
    englishTitle: "Let’s Play Shloka Antyakshari",
    page: "Chapter 6",
    category: "shlokas",
    genreBadge: "काव्यक्रीडा · Poetry Game",
    theme: "Engaging classroom Antyakshari game reciting shlokas across poetic meters",
    grammarFocus: "श्लोकरचना, अनुष्टुप्-छन्दः, सन्धयः",
    status: "available",
    icon: "🎵",
  },
  {
    id: "gsde107",
    num: "Chapter 7",
    chNumber: "Chapter 7",
    title: "ईशावास्यम् इदं सर्वम्",
    englishTitle: "The Divine in Everything",
    page: "Chapter 7",
    category: "shlokas",
    genreBadge: "उपनिषद् · Spiritual Wisdom",
    theme: "Isha Upanishad teachings on renunciation, detachment, and divine omnipresence",
    grammarFocus: "अव्ययानि, सर्वनामपदानि, सप्तमी",
    status: "available",
    icon: "🕉️",
  },
  {
    id: "gsde108",
    num: "Chapter 8",
    chNumber: "Chapter 8",
    title: "हितं मनोहारि च दुर्लभं वचः",
    englishTitle: "Beneficial & Pleasing Words are Rare",
    page: "Chapter 8",
    category: "dialogue",
    genreBadge: "संवादः · Class Discussion",
    theme: "Kirātārjunīyam wisdom: words that are simultaneously beneficial and pleasant",
    grammarFocus: "विशेषण-विशेष्य-भावः, सुभाषित-प्रयोगाः",
    status: "available",
    icon: "💬",
  },
  {
    id: "gsde109",
    num: "Chapter 9",
    chNumber: "Chapter 9",
    title: "अन्नाद् भवन्ति भूतानि",
    englishTitle: "All Beings Arise from Food",
    page: "Chapter 9",
    category: "dialogue",
    genreBadge: "संवादः · Science & Ecology",
    theme: "Gita ecology: The cosmic cycle of rain, agriculture, food, and living beings",
    grammarFocus: "पञ्चमी-विभक्तिः (अपादानम् — अन्नात्)",
    status: "available",
    icon: "🌾",
  },
  {
    id: "gsde110",
    num: "Chapter 10",
    chNumber: "Chapter 10",
    title: "दशमः कः ?",
    englishTitle: "Who is the Tenth? (Story of Wisdom)",
    page: "Chapter 10",
    category: "stories",
    genreBadge: "हास्यकथा · Humorous Riddle",
    theme: "The famous philosophical tale of the ten boys counting everyone except oneself",
    grammarFocus: "संख्यावाचक-शब्दाः (एकः तः दशमः)",
    status: "available",
    icon: "🤔",
  },
  {
    id: "gsde111",
    num: "Chapter 11",
    chNumber: "Chapter 11",
    title: "द्वीपेषु रम्यः द्वीपोऽण्डमानः",
    englishTitle: "The Beautiful Andaman Islands",
    page: "Chapter 11",
    category: "dialogue",
    genreBadge: "भूगोलः · Geography & Travel",
    theme: "Rich exploration of Andaman & Nicobar archipelago, freedom struggle, and nature",
    grammarFocus: "सप्तमी-विभक्तिः, गुणवाचक-विशेषणानि",
    status: "available",
    icon: "🏝️",
  },
  {
    id: "gsde112",
    num: "Chapter 12",
    chNumber: "Chapter 12",
    title: "वीराङ्गना पन्नाधाया",
    englishTitle: "The Heroic Panna Dhai",
    page: "Chapter 12",
    category: "stories",
    genreBadge: "इतिहासः · Heroic History",
    theme: "The supreme sacrifice of foster-mother Panna Dhai saving Prince Uday Singh of Mewar",
    grammarFocus: "लङ्-लकारः (भूतकालः / Past Tense)",
    status: "available",
    icon: "🛡️",
  },
  {
    id: "gsde113",
    num: "Extra Study",
    chNumber: "Extra Study",
    title: "वर्णमात्रा-परिचयः",
    englishTitle: "Alphabet & Accent Guide",
    page: "Extra Study",
    category: "grammar",
    genreBadge: "ध्वनिविज्ञानम् · Phonetics",
    theme: "Comprehensive guide to Hrasva, Dirgha, and Pluta vowels and Vedic pitch accents",
    grammarFocus: "मात्राज्ञानम्, उदात्तः-अनुदात्तः-स्वरितः",
    status: "available",
    icon: "🔤",
  },
  {
    id: "gsde114",
    num: "Appendix 1",
    chNumber: "Appendix 1",
    title: "शब्दरूपाणि",
    englishTitle: "Noun Declensions (Shabdarupani)",
    page: "Appendix 1",
    category: "grammar",
    genreBadge: "व्याकरणम् · Noun Tables",
    theme: "Complete declension reference for masculine, feminine, neuter nouns and pronouns",
    grammarFocus: "अजन्त-हलन्त-रूपाणि, 7 विभक्तयः",
    status: "available",
    icon: "📊",
  },
  {
    id: "gsde115",
    num: "Appendix 2",
    chNumber: "Appendix 2",
    title: "धातुरूपाणि",
    englishTitle: "Verb Conjugations (Dhaturupani)",
    page: "Appendix 2",
    category: "grammar",
    genreBadge: "व्याकरणम् · Verb Paradigms",
    theme: "Full verb conjugation paradigms for Parasmaipada, Atmanepada & Ubhayapada roots",
    grammarFocus: "लट्, लोट्, लङ्, विधिलिङ्, लृट् लकाराः",
    status: "available",
    icon: "⚡",
  },
];
